import { PressEvent } from '@react-types/shared'
import { ContentType, Presser } from 'components/ContentType/ContentType'
import { ContentTypeProps } from 'components/ContentType/Types'
import { AspectRatioKey, DesignChannel, DesignChannels } from 'components/NewFileModal/Types'
import { MobileWizardsDrawer } from 'components/Wizards/MobileWizards/MobileWizardsDrawer/MobileWizardsDrawer'
import { invert } from 'lodash'
import { PropsWithChildren } from 'react'
import { useRootStore } from 'stores/RootStore'
import { TextChannelKey } from 'types'
import { Wizard } from '../Types'
import { useIsNewWizardFlowEnabled } from 'components/Wizards/MobileWizards/hooks/useIsNewWizardFlowEnabled'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { usePaywallGuard } from 'hooks/usePaywallGuard'

export type WizardOpenerProps = Omit<ContentTypeProps, 'type'> & {
  type: Wizard
}

export const WizardOpener = (props: PropsWithChildren<WizardOpenerProps>) => {
  const { children, type } = props
  let contentType = type
  const { drawersStore } = useRootStore()
  const { isNewWizardFlowEnabled } = useIsNewWizardFlowEnabled()

  const guardedHandlePress = usePaywallGuard(() => {
    drawersStore.openDrawer(MobileWizardsDrawer, { channel: type as ChannelType | DesignChannel })
  })

  if (isNewWizardFlowEnabled(type)) {
    return <Presser onPress={guardedHandlePress}>{children}</Presser>
  }

  // Legacy flow for types that don't use the new wizard
  // For design channels, convert to the appropriate aspect ratio
  const ChannelToAspectRatio = invert(DesignChannels)
  const DesignChannelValues = Object.values(DesignChannel) as string[]

  if (DesignChannelValues.includes(type)) {
    contentType = ChannelToAspectRatio[type] as AspectRatioKey
  }

  const onPress = (e: PressEvent) => {
    drawersStore.closeAllDrawers()
    props.onPress?.(e)
  }

  return (
    <ContentType {...props} type={contentType as TextChannelKey | AspectRatioKey} onPress={onPress}>
      {children}
    </ContentType>
  )
}
